import dynamic from 'next/dynamic';

import Root from './Root';

const Modal = {
  Body: dynamic(() => import('./Body'), { ssr: false }),
  CloseButton: dynamic(() => import('./CloseButton'), { ssr: false }),
  Header: dynamic(() => import('./Header'), { ssr: false }),
  Heading: dynamic(() => import('./Heading'), { ssr: false }),
  Root,
};

export default Modal;
